import { API_BASE_URL } from '@/constants';

import axios from './index';
import { objectToFormData } from './helpers';


export function signUp(email, promoCode) {
  return axios.post(`${API_BASE_URL}/sign-up`, objectToFormData({
    email,
    promo_code: promoCode,
  }));
}

export function authorize(login, password) {
  return axios.post(`${API_BASE_URL}/sign-in`, {
    login,
    password,
  });
}

export function restorePassword(email) {
  return axios.post(`${API_BASE_URL}/restore-password`, { email });
}

export function isRestorePasswordCodeCorrect(code) {
  return axios.post(`${API_BASE_URL}/check-restore-password-code`, { code });
}

export function changePassword(code, password) {
  return axios.post(`${API_BASE_URL}/change-password`, {
    code,
    password,
  });
}
